module.exports = __webpack_public_path__ + "static/img/letbane-logo-text.587ab6f3.svg";